import { Col, Row } from "antd";
import { ReactElement } from "react";
import { useAuth } from "oidc-react";
import { Navigate } from "react-router-dom";
import { RoutingPaths } from "../routing/routingContainer";
import styles from "./authenticationLayout.module.less";

export default function AuthenticationLayout(props: AuthenticationLayoutProps) {
    const auth = useAuth();

    if (auth.userData) {
        return <Navigate to={RoutingPaths.mainPage.route} replace={true} />;
    }

    return <Row className={styles.rowContainer}>
        <Col className={styles.container}>
            <Row justify="center">
                <Col xs={22} md={16}>
                    {props.title && <>
                        <h1>{props.title}</h1>
                    </>}
                    {props.children}
                </Col>
            </Row>
        </Col>
    </Row>;
}

interface AuthenticationLayoutProps {
    title?: string,
    children: ReactElement
}
